<template>
  <div class="container">
    <h2>{{ page.Title }}</h2>
    <div
      class="description-insurance"
      v-if="page.Content"
      v-html="page.Content"
    ></div>
    <div class="row mt-5 mb-4">
      <h2 class="mx-3">
        {{ page.Questions[0].Header }}
      </h2>
    </div>
    <div
      class="insurance-section-description mb-4"
      v-if="page.Questions[0].Description"
      v-html="page.Questions[0].Description"
    ></div>
    <div class="row" v-if="!this.$isMobile()">
      <div
        class="col-md-4"
        v-for="indbo in page.Questions[0].Options"
        :key="indbo.ID"
      >
        <Insurance
          v-model="page.Questions[0].Value"
          :selectedInsurance="page.Questions[0].Value"
          :policy="indbo"
          :buttonText="
            page.Questions[0].Value === indbo.ID
              ? page.Questions[0].BtnChosen
              : page.Questions[0].BtnText
          "
          :mnthText="page.Questions[0].PremiumPostfix"
          :selectedClass="'selected'"
          @getInsuranceData="selectPolicyConditions(homeInsurance)"
        />
      </div>
    </div>
    <div class="row" v-if="this.$isMobile()">
      <swiper
        class="swiper pt-3 pb-5"
        :options="insuranceSwiperOptions"
        ref="insuranceSwiper"
        @slideChange="changeSwiperIndex()"
      >
        <swiper-slide
          v-for="indbo in page.Questions[0].Options"
          :key="indbo.ID"
        >
          <Insurance
            v-model="page.Questions[0].Value"
            :selectedInsurance="page.Questions[0].Value"
            :policy="indbo"
            :buttonText="
              page.Questions[0].Value === indbo.ID
                ? page.Questions[0].BtnChosen
                : page.Questions[0].BtnText
            "
            :mnthText="page.Questions[0].PremiumPostfix"
            :selectedClass="'selected'"
            :activeSlide="activeInsuranceSlide"
            @getInsuranceData="selectPolicyConditions(homeInsurance)"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="mt-3 insurance-link">
      <span class="mr-3">
        <svg
          width="17px"
          height="16px"
          viewBox="0 0 17 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="icons-/-arrow-right"
            transform="translate(5, -5) scale(-1,1)"
            transform-origin="center"
            fill="#668C9F"
          >
            <polygon
              id="Combined-Shape"
              points="8.1 11 13.7 5.4 12.3 4 4.3 12 12.3 20 13.7 18.6 8.1 13 20.3 13 20.3 11"
            ></polygon>
          </g>
        </svg>
      </span>
      <span v-html="page.Questions[0].CodanLink"></span>
      <div
        class="row mt-2 alert alert-warning alert-note"
        v-if="inboInsuranceSelected && page.BottomNote"
      >
        {{ page.BottomNote }}
      </div>
    </div>
    <div class="row mt-5">
      <h2 class="mx-3">
        {{ page.Questions[1].Header }}
      </h2>
    </div>
    <div class="row mt-4" v-if="!this.$isMobile()">
      <div
        class="col-lg-4 col-sm-6"
        v-for="ulykke in page.Questions[1].Options"
        :key="ulykke.ID"
      >
        <Insurance
          v-model="page.Questions[1].Value"
          :selectedInsurance="page.Questions[1].Value"
          :policy="ulykke"
          :buttonText="
            page.Questions[1].Value === ulykke.ID
              ? page.Questions[1].BtnChosen
              : page.Questions[1].BtnText
          "
          :mnthText="page.Questions[0].PremiumPostfix"
          :selectedClass="'selected-extra'"
          :isExtra="true"
          @getInsuranceData="selectPolicyConditions(accidentInsurance)"
        />
      </div>
    </div>
    <div class="row mt-4" v-else>
      <swiper
        class="swiper-accident swiper pb-5"
        :options="accidentSwiperOptions"
      >
        <swiper-slide
          v-for="ulykke in page.Questions[1].Options"
          :key="ulykke.ID"
        >
          <Insurance
            v-model="page.Questions[1].Value"
            :selectedInsurance="page.Questions[1].Value"
            :policy="ulykke"
            :buttonText="
              page.Questions[1].Value === ulykke.ID
                ? page.Questions[1].BtnChosen
                : page.Questions[1].BtnText
            "
            :mnthText="page.Questions[0].PremiumPostfix"
            :selectedClass="'selected-extra'"
            :isExtra="true"
            @getInsuranceData="selectPolicyConditions(accidentInsurance)"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="mt-3 insurance-link">
      <span class="mr-3">
        <svg
          width="17px"
          height="16px"
          viewBox="0 0 17 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="icons-/-arrow-right"
            transform="translate(5, -4) scale(-1,1)"
            transform-origin="center"
            fill="#668C9F"
          >
            <polygon
              id="Combined-Shape"
              points="8.1 11 13.7 5.4 12.3 4 4.3 12 12.3 20 13.7 18.6 8.1 13 20.3 13 20.3 11"
            ></polygon>
          </g>
        </svg>
      </span>
      <span v-html="page.Questions[1].CodanLink"></span>
    </div>
    <div class="row" v-if="insuranceSelected">
      <div class="col-lg-6 col-12">
        <h2 class="mt-5 mb-4">
          {{ page.TotalInsuranceHeader }}
        </h2>
        <PriceInsurance v-if="insuranceSelected" :insuranceData="page" />
      </div>
    </div>
    <div class="row" v-if="insuranceSelected">
      <div class="col-lg-6 col-12">
        <h2 class="mt-5 mb-5">
          {{ page.CoverageDate }}
        </h2>
        <div class="mt-5 mb-2">
          <StartDateInsurance
            v-model="page.Questions[2].Value"
            :value="page.Questions[2].Value"
            :id="page.Questions[2].QID"
            :studentInsurance="true"
            :config="page.Questions[2].Config"
          />
        </div>
      </div>
    </div>
    <div class="row" v-if="insuranceSelected">
      <div class="col-12 insurance-link">
        <h2 class="mt-5 mb-4">
          {{ page.ConditionsHeader }}
        </h2>
        {{ page.ConditionsText }}
        <span v-html="page.Questions[0].ConditionLink"></span>
        og
        <span v-html="page.Questions[1].ConditionLink"></span>
      </div>
      <div class="col-12">
        <DoCheckbox
          v-model="page.Questions[3].Value"
          :value="page.Questions[3].Value"
          :id="page.Questions[3].QID"
          :config="page.Questions[3].Config"
          :options="page.Questions[3].Options"
          :insurance="true"
          @doChange="acceptInsurance"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Insurance from '../inputs/_DoInsurance';
  import PriceInsurance from '../inputs/_DoInsurancePrice';
  import StartDateInsurance from '../inputs/_DoStartDate';
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

  export default {
    components: {
      Insurance,
      PriceInsurance,
      StartDateInsurance,
      Swiper,
      SwiperSlide,
    },
    data() {
      return {
        homeInsurance: 'studentInsurance',
        accidentInsurance: 'studentInsuranceExtra',
        activeInsuranceSlide: 1,
        insuranceSwiperOptions: {
          initialSlide: 1,
          breakpoints: {
            320: {
              slidesPerView: 1.5,
              spaceBetween: 20,
            },
            575: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
          },
          centeredSlides: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        accidentSwiperOptions: {
          breakpoints: {
            320: {
              slidesPerView: 1.3,
              spaceBetween: 20,
            },
            575: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
          },
          centeredSlides: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      };
    },
    inject: {
      $validator: '$validator',
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    methods: {
      selectPolicyConditions(policyToSet) {
        const { Value: homeInsuranceValue } = this.page.Questions[0];
        const { Value: accidentInsuranceValue } = this.page.Questions[1];

        this.checkIfInsurancesAreEmpty(
          homeInsuranceValue,
          accidentInsuranceValue
        );

        if (policyToSet === this.homeInsurance) {
          sessionStorage.clear();
          sessionStorage.setItem(policyToSet, homeInsuranceValue);
        } else {
          sessionStorage.clear();
          sessionStorage.setItem(policyToSet, accidentInsuranceValue);
        }
        this.setPolicyAcceptanceRequired(
          homeInsuranceValue,
          accidentInsuranceValue
        );

        this.$store.dispatch('doNewData', this.page.JobID);
      },
      checkIfInsurancesAreEmpty(homeInsuranceValue, accidentInsuranceValue) {
        if (homeInsuranceValue === '' && accidentInsuranceValue === '') {
          this.page.Questions[3].Value = false;
        }
      },
      setPolicyAcceptanceRequired(homeInsuranceValue, accidentInsuranceValue) {
        this.page.Questions[3].Config.Validation.required =
          !!homeInsuranceValue || !!accidentInsuranceValue;
      },
      acceptInsurance() {
        const value = this.page.Questions[3].Value;
        sessionStorage.clear();
        sessionStorage.setItem('acceptedInsurance', value);
        this.$store.dispatch('doNewData', this.page.JobID);
      },
      changeSwiperIndex() {
        const activeIndex = this.swiper.activeIndex;
        this.activeInsuranceSlide = activeIndex;
      },
    },
    computed: {
      insuranceSelected() {
        return this.page.Questions[0].Value || this.page.Questions[1].Value;
      },
      inboInsuranceSelected() {
        return this.page.Questions[0].Value;
      },
      swiper() {
        return this.$refs.insuranceSwiper.$swiper;
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/assets/scss/studentinsurance';
  .alert-note {
    background-color: rgba(233, 160, 56, 0.3);
  }
</style>
